import React, { FC, useState } from "react";
import { useAppDispatch } from "src/hooks/redux";
import {
  addToWatchlistAsync,
  removeFromWatchlistAsync,
} from "src/redux/watchlist/actions";
import { AddToFavoriteButton } from "../AddToFavoriteButton";

interface Props {
  id: number;
  saved_count: number;
  isFavoriteInquiry: boolean;
  setIsFavorite: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AddToWatchlist: FC<Props> = ({
  id,
  isFavoriteInquiry,
  saved_count,
  setIsFavorite,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentSavedCount, setCurrentSavedCount] = useState(saved_count);

  const dispatch = useAppDispatch();

  const onSuccessAddToWatchlist = () => {
    setIsFavorite(true);
    setIsLoading(false);
    setCurrentSavedCount(currentSavedCount + 1);
  };

  const onSuccessRemoveFromWatchlist = () => {
    setIsFavorite(false);
    setIsLoading(false);
    setCurrentSavedCount(currentSavedCount - 1);
  };

  const addToWatchlist = () => {
    setIsLoading(true);
    dispatch(
      addToWatchlistAsync({
        id,
        onSuccess: onSuccessAddToWatchlist,
      })
    );
  };

  const removeFromWatchlist = () => {
    setIsLoading(true);
    dispatch(
      removeFromWatchlistAsync({
        id,
        onSuccess: onSuccessRemoveFromWatchlist,
      })
    );
  };

  return (
    <AddToFavoriteButton
      saved_count={currentSavedCount}
      isFavorite={isFavoriteInquiry}
      addToFavorites={addToWatchlist}
      removeFromFavorites={removeFromWatchlist}
      isLoading={isLoading}
    />
  );
};
